import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MarketingStudio from './MarketingStudio';

const SECTIONS = [
  { id: 'cover',   name: 'Portada' },
  { id: 'summary', name: 'Resumen General' },
  { id: 'meta',    name: 'Meta Ads' },
  { id: 'google',  name: 'Google Ads' },
  { id: 'ga4',     name: 'Google Analytics' },
  { id: 'gsc',     name: 'Search Console' },
];

export default function MarketingStudioPage() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('summary');

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f8fafc' }}>
      <aside style={{ width: 288, background: '#fff', borderRight: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', padding: '24px', gap: 4 }}>
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontWeight: 700, fontSize: 18, color: '#1e293b', marginBottom: 8 }}>Marketing Studio</div>
          <button onClick={() => navigate('/dashboard')} style={{ fontSize: 13, color: '#6366f1', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
            ← Volver al Dashboard
          </button>
        </div>
        <nav style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {SECTIONS.map(s => (
            <button key={s.id} onClick={() => setActiveSection(s.id)} style={{ textAlign: 'left', padding: '10px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 15, fontWeight: activeSection === s.id ? 600 : 400, background: activeSection === s.id ? '#eef2ff' : 'transparent', color: activeSection === s.id ? '#4f46e5' : '#64748b' }}>
              {s.name}
            </button>
          ))}
        </nav>
      </aside>
      <main style={{ flex: 1, overflow: 'auto' }}>
        <MarketingStudio embeddedSection={activeSection} onSectionChange={setActiveSection} />
      </main>
    </div>
  );
}
